// Codes the API sets when QuickBooks itself has to be connected or reconnected.
// Other QuickBooks failures come back as 409s too — a sync already running for
// the record, a vendor that no longer matches the bill, a pending company
// switch — but reconnecting fixes none of them, so those must show their own
// message instead of the connect modal.
const CONNECTION_ERROR_CODES = new Set(['QB_NOT_CONNECTED', 'QB_REAUTH_REQUIRED']);

export function isQuickBooksConnectionError(data) {
  return CONNECTION_ERROR_CODES.has(data?.code);
}
